<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">
            <router-link to="/indextest" class="btn btn-info">
              返回首頁 ←
            </router-link>
          </div>
        </div>
        <!--九宮格影像畫面-->
        <div class="row w-100 justify-content-start">
          <div style="width: calc(100vw - 50px); height: calc(100vh - 20px)">
            <div class="matrix-board">
              <div
                style="left: 0px; top: 0px; width: 507.667px; height: 315.667px"
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="石梯坪1"
                      class="matrix-board-panel-title-content"
                    >
                      石梯坪1
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/stone-3.312ebfbc.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 507.667px;
                  top: 0px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="石梯坪2"
                      class="matrix-board-panel-title-content"
                    >
                      石梯坪2
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/stone-2.028b408c.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 1015.33px;
                  top: 0px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="石梯坪3"
                      class="matrix-board-panel-title-content"
                    >
                      石梯坪3
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/stone-1.369bf9cc.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 0px;
                  top: 315.667px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="八仙洞1"
                      class="matrix-board-panel-title-content"
                    >
                      八仙洞1
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/eight-2.65d587a9.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 507.667px;
                  top: 315.667px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="八仙洞2"
                      class="matrix-board-panel-title-content"
                    >
                      八仙洞2
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/eight-1.64375385.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 1015.33px;
                  top: 315.667px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="八仙洞3"
                      class="matrix-board-panel-title-content"
                    >
                      八仙洞3
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/eight-3.8ca0bf03.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 0px;
                  top: 631.333px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="三仙台1"
                      class="matrix-board-panel-title-content"
                    >
                      三仙台1
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/three-1.221b242b.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 507.667px;
                  top: 631.333px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="三仙台2"
                      class="matrix-board-panel-title-content"
                    >
                      三仙台2
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/three-2.fa6c147d.jpg" />
                </div>
              </div>
              <div
                style="
                  left: 1015.33px;
                  top: 631.333px;
                  width: 507.667px;
                  height: 315.667px;
                "
              >
                <div class="matrix-board-panel">
                  <div class="matrix-board-panel-title">
                    <div
                      title="三仙台3"
                      class="matrix-board-panel-title-content"
                    >
                      三仙台3
                    </div>
                  </div>
                  <div class="matrix-board-panel-zoom">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVpJREFUWEftl+ENgjAQhekGjuAG6gTKD3/rBjqCTqALGN3AOIEjCBOoGzCCToDvmdaUBiNtoRhjk0tjLfe+Xu+OIPI8P0dR1Ie1McYCAHkbylJzogCuQohgUcCZRwA4wV4AKQC4GGT8AX4zAjhVBwk0g3FWI0NuHczEaiQCcDqF0LEkiweAuOjrZQARNgnfEpCOWc5bzVcM10koAIqzvvVrCAOA0+vivPcubAhrHsAUR8jnWFtDfEEQ/L41dgVl4p9yqbYkdBEnXC0AruLvAKxeRj7i3gC+4lYAsr32kMWpfLBQasz2TwlX9n/lVoyNLCN2tRjGUlJN5uAqbhsB1vIKtpQzO5yXuCuAiqS3uC9AAgcXhJ8RcR42OcAk2xtKdwDoLxtrkMoAMlxdzDQ1GIFCb7clsAKwdV5l/x/gKyOQ4e6Y8aEGW/oO9vo0CyVs6jwBePJgH6YGweYBIK9zVYIj2s8AAAAASUVORK5CYII="
                      alt=""
                      class="matrix-board-panel-zoom-img"
                    />
                  </div>
                  <img src="/img/three-3.f89ba553.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {};
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
  },
};
</script>